const confirmPassword = function() {
  let password = $('#password')
  let passwordConfirm = $('#password_confirm')
  let username = $('#username')

  if (passwordConfirm.length == 0) return

  $('#submitPassword').attr('disabled', 'disabled')

  if (password.val() == passwordConfirm.val() && password.val().trim().length >= 8) {
    $('#confirmPasswordMessage, #passwordMismatchMessage').addClass('d-none')

    if (username.length == 0 || username.val().trim() != '') {
      $('#submitPassword').removeAttr('disabled')
    }
  } else {
    if (passwordConfirm.val().trim() != '') {
      $('#confirmPasswordMessage').addClass('d-none')
      $('#passwordMismatchMessage').removeClass('d-none')
    } else {
      $('#confirmPasswordMessage').removeClass('d-none')
      $('#passwordMismatchMessage').addClass('d-none')
    }
  }
}

$(document).on('change keyup', '#password, #password_confirm, #username', confirmPassword)
$(confirmPassword)
